import React, { useState, useEffect } from 'react';
import FeedBackcss from '../styles/feedback.module.css';
import NavigationBar from '../components/NavigationBar';
import Footer from '../components/Footer';
import Faqs from '../components/Faqs';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import API_URL from "../config/api";

function Feedback() {
    const user = JSON.parse(localStorage.getItem("user"));
    const isAdmin = user?.role === "admin";
    const uid = user?.id;
    const [modalVisible, setModalVisible] = useState(false);
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [content, setContent] = useState("");
    const [feedbacks, setFeedbacks] = useState([]);
    const [pic, setPic] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState("");
    const openModal = () => {
        if (user) {
            setModalVisible(true);
        } else {
            toast.error("You need to login first.");
        }
    };

    const closeModal = () => {
        setModalVisible(false);
        setName("");
        setEmail("");
        setContent("");
        setPic(null);
    };

    const handleFileChange = (e) => {
        setPic(e.target.files[0]);
    };

    /* ==========================================
       LOAD FEEDBACKS
    ========================================== */

    const fetchFeedbacks = async () => {
        try {
            const response = await fetch(`${API_URL}/feedback/get_feedback.php`
            );
            const data = await response.json();
            setFeedbacks(data);
        } catch (err) {
            console.error(err);
            setError(err.message);
        }
    };

    useEffect(() => {
        fetchFeedbacks();
    }, []);

    /* ==========================================
       SUBMIT FEEDBACK
    ========================================== */

    const submitFeedback = async (e) => {
        e.preventDefault();
        if (!pic) {
            toast.error("Please upload an image.");
            return;
        }
        setIsLoading(true);
        try {
            const formData = new FormData();

            formData.append("name", name);
            formData.append("email", email);
            formData.append("content", content);
            formData.append("posted_by", uid);
            formData.append("image", pic);

            const response = await fetch(`${API_URL}/feedback/add_feedback.php`,
                {
                    method: "POST",
                    body: formData
                }
            );

            const data = await response.json();

            if (!data.success) {
                throw new Error(data.message);
            }
            toast.success("Feedback submitted successfully!");
            closeModal();
            fetchFeedbacks();
        } catch (err) {
            console.error(err);
            toast.error(err.message);
            setError(err.message);
        } finally {
            setIsLoading(false);
        }
    };

    /* ==========================================
       DELETE FEEDBACK
    ========================================== */

    const deleteFeedback = async (feedbackId) => {
        if (!window.confirm("Are you sure you want to delete this feedback?")) {
            return;
        }
        if (!isAdmin) {
            toast.error("Unauthorized operation.");
            return;
        }
        try {
            const response = await fetch(`${API_URL}/feedback/delete_feedback.php`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        id: feedbackId
                    })
                }
            );

            const data = await response.json();

            if (!data.success) {
                throw new Error(data.message);
            }

            toast.success("Feedback deleted successfully!");
            fetchFeedbacks();

        } catch (err) {
            console.error(err);
            toast.error(err.message);
        }
    };

    /* ==========================================
       JSX
    ========================================== */

    return (
        <>
            <NavigationBar />
            <header className={FeedBackcss.header}>
                <div className={FeedBackcss.container}>
                    <div className={FeedBackcss.containerLeft}>
                        <br />
                        <br />
                        <br />
                        <h1>Read what our customers love about us</h1>
                        <p>
                            Welcome to Arboreatrix! Your feedback is valuable in helping us improve our system.
                            Please take a moment to share your thoughts and suggestions with us.
                            Your input will guide us in enhancing your experience.
                        </p>
                        <p>
                            Additionally, if you've discovered a new indigenous fruit tree species
                            that you'd like us to explore, please let us know!
                            We're passionate about biodiversity and would love to investigate further.
                        </p>
                        <p>
                            Thank you for being a part of our community
                            and contributing to the growth of Arboreatrix!
                        </p>
                        <button onClick={openModal}>
                            Give Us Your Feedback
                        </button>
                    </div>
                    <div className={FeedBackcss.containerRight}>
                        {feedbacks.map((feedback) => (
                            <div
                                key={feedback.id}
                                className={FeedBackcss.card}
                            >
                                {isAdmin && (
                                    <button
                                        className={FeedBackcss.deleteButton}
                                        onClick={() => deleteFeedback(feedback.id)}
                                    >
                                        X
                                    </button>
                                )}
                                <img
                                    src={feedback.imgurl || "./bg.png"}
                                    alt="feedback"
                                />
                                <div className={FeedBackcss.card__content}>
                                    <span>
                                        <i className="ri-double-quotes-l"></i>
                                    </span>
                                    <div className={FeedBackcss.card__details}>
                                        <p className="truncate-text">
                                            {feedback.content}
                                        </p>
                                        <h4>
                                            - {feedback.name}
                                        </h4>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                {modalVisible && (
                    <div
                        id="feedbackModal"
                        className={FeedBackcss.modal}
                        style={{ display: "block" }}
                    >
                        <div className={FeedBackcss.modalContent}>
                            <span
                                className={FeedBackcss.close}
                                onClick={closeModal}
                            >
                                &times;
                            </span>
                            <h1>Give Us Your Feedback</h1>
                            <form
                                className={FeedBackcss.form1}
                                onSubmit={submitFeedback}
                            >
                                <div className={FeedBackcss.formGroup}>
                                    <label htmlFor="name">
                                        Your Name:
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control w-100"
                                        id="name"
                                        placeholder="Name"
                                        value={name}
                                        required
                                        onChange={(e) => setName(e.target.value)}
                                    />
                                </div>
                                <div className={FeedBackcss.formGroup}>
                                    <label htmlFor="email">
                                        Your Email:
                                    </label>
                                    <input
                                        type="email"
                                        className="form-control w-100"
                                        id="email"
                                        placeholder="Email"
                                        value={email}
                                        required
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                </div>
                                <div className={FeedBackcss.formGroup}>
                                    <label htmlFor="feedback">
                                        Your Feedback:
                                    </label>
                                    <textarea
                                        className="form-control w-100"
                                        id="feedback"
                                        rows="4"
                                        placeholder="What do you want to say?"
                                        value={content}
                                        required
                                        onChange={(e) => setContent(e.target.value)}
                                    />
                                </div>
                                <div className={FeedBackcss.formGroup}>
                                    <label htmlFor="pic">
                                        Upload Image
                                    </label>
                                    <input
                                        type="file"
                                        className="form-control w-100"
                                        accept="image/*"
                                        required
                                        onChange={handleFileChange}
                                    />
                                </div>
                                <button
                                    type="submit"
                                    className="btn btn-primary w-100"
                                    disabled={isLoading}
                                >
                                    {isLoading
                                        ? "Submitting..."
                                        : "Submit Feedback"}
                                </button>
                            </form>
                        </div>
                    </div>
                )}
            </header>
            <div className="faqss">
                <Faqs />
            </div>
            <footer className="footer1">
                <Footer />
            </footer>

            {error && (
                <p className="error">
                    {error}
                </p>
            )}

            <ToastContainer
                position="top-center"
                autoClose={2000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </>
    );
}

export default Feedback;